if (!customElements.get('postit-pack-selector')) {
  customElements.define(
    'postit-pack-selector',
    class PostitPackSelector extends HTMLElement {
      connectedCallback() {
        this.quantityInput = this.querySelector('.postit-pack-selector__quantity-input');
        this.packInputs = this.querySelectorAll('input[type="radio"]');
        this.sectionId = this.dataset.sectionId;
        this.packInputs.forEach((input) => input.addEventListener('change', this.onChange.bind(this)));
        const checked = this.querySelector('input[type="radio"]:checked');
        if (checked) this.applySelection(checked, false);
      }

      onChange(event) {
        this.applySelection(event.currentTarget, true);
      }

      applySelection(input, dispatch = true) {
        this.querySelectorAll('.postit-pack-selector__option').forEach((option) => option.classList.remove('is-selected'));
        input.closest('.postit-pack-selector__option')?.classList.add('is-selected');
        if (this.quantityInput) this.quantityInput.value = input.dataset.packQuantity || input.value;

        if (!dispatch) return;

        window.dispatchEvent(
          new CustomEvent('postit-pack-change', {
            detail: {
              sectionId: this.sectionId,
              quantity: parseInt(input.dataset.packQuantity || input.value || '1', 10),
              totalPrice: parseInt(input.dataset.packTotalPrice || '0', 10),
              eachPrice: parseInt(input.dataset.packEachPrice || '0', 10),
            },
          })
        );
      }
    }
  );
}
